import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useParams, Redirect, useLocation, } from "react-router-dom";


import ObservationForm from "../components/observation/ObservationForm";
import { makeAppMessage } from "../store/reducers/messageReducer";
import { createShowNewMessageAction } from "../store/actions/messageActions";
import { useDispatch } from "react-redux";
import { PageTemplate } from "../components/PageTemplate/PageTemplate";
import { getRouteHrefById } from "../../../routing";
import { HavainnotRouteId } from "../../routes";
import * as StorageKey from "../constants/StorageKeys";
import { getState, setState, useLocalStorage } from "@/sg-core";



interface INewObservationPage { };

const NewObservationPage: React.FC<INewObservationPage> = (props) => {
    const { t, i18n } = useTranslation();

    const params = useParams<{ formType: string }>();
    const { state } = useLocation<{ clearStorage?: boolean }>();

    const formTypeGuid = params.formType;

    const dispatch = useDispatch();

    const [submitted, setSubmitted] = useState<boolean>(false)


    const initialFormData = useMemo(() => getState(StorageKey.NEW_OBSERVATION_EDITS), [i18n.language])
    const setStoredData = (values: any) => {
        setState(StorageKey.NEW_OBSERVATION_EDITS, values)
    };

    useLayoutEffect(() => {
        if (state?.clearStorage) {
            localStorage.removeItem(StorageKey.NEW_OBSERVATION_EDITS);
            window.history.replaceState({}, document.title)
        }
    }, []);

    if (submitted) {
        const appMessage = makeAppMessage({
            header: t("Tallennus onnistui"),
            content: t("Havainto tallennettiin onnistuneesti ja odottaa käsittelijää."),
            success: true
        });
        dispatch(createShowNewMessageAction(appMessage))

        return <Redirect to={{
            pathname: getRouteHrefById(HavainnotRouteId.WorklistPage),
            state: { messageId: appMessage.id }
        }} />
    };

    if (!formTypeGuid) {
        return <Message content={t("Virhe ei valittua lomaketta")} negative />;
    }

    return (
        <PageTemplate>
            <ObservationForm
                formTypeGuid={formTypeGuid}
                onSuccess={() => setSubmitted(true)}
                onChange={setStoredData}
                initialFormData={state?.clearStorage ? undefined : initialFormData}
            />
        </PageTemplate>
    );
};

const MemoizedNewObservationPage = React.memo(NewObservationPage);

const NewObservationPageContainer: React.FC = () => {
    return <MemoizedNewObservationPage />;
};

export default NewObservationPageContainer;
